<div class="container-fluid cw-background">
  <mat-card class="mat-elevation-z8 mt-3 mb-5">
    <mat-card-title class="title-page">Quotes List</mat-card-title>
    <button *ngIf="currentUser.hasRight(['admin'])" mat-fab class="create" color="accent" (click)="onAddQuote()">
      <mat-icon>add</mat-icon>
    </button>

    <mat-card-content class="mt-4">
      <div class="container-fluid">
        <app-data-table
          *ngIf="tableConfig"
          [config]="tableConfig"
          (getData)="quoteTableService.getQuotes($event)"
          (updateData)="quoteTableService.update($event)"
        ></app-data-table>
      </div>
    </mat-card-content>
  </mat-card>
</div>
